import * as React from "react";
import {
  List, Datagrid, TextField, NumberField, FunctionField,
  Show, SimpleShowLayout, useRecordContext,
} from "react-admin";
import { JsonField } from "../../components/JsonField";
import { TechInfo } from "../../components/ui";

// RecordingJob : id, roomId, status (PENDING/RECORDING/PROCESSING/READY/FAILED),
// duration (sec), videoUrl, createdAt (LocalDateTime).
const RecordingPlayer = () => {
  const r = useRecordContext();
  if (!r?.videoUrl) return null;
  return (
    <video controls width="100%" style={{ maxWidth: 600 }}>
      <source src={r.videoUrl} />
    </video>
  );
};

export default {
  list: () => (
    <List sort={{ field: "createdAt", order: "DESC" }} perPage={50} pagination={false}>
      {/* Pas de DELETE côté backend : aucune action groupée */}
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="status" />
        <FunctionField label="Durée" render={(r) => r?.duration ? `${r.duration} s` : "—"} />
        <FunctionField label="Vidéo" render={(r) => r?.videoUrl
          ? <a href={r.videoUrl} target="_blank" rel="noopener noreferrer" style={{ color: "#0d7377" }}>Voir →</a>
          : "—"} />
        <TextField source="createdAt" label="Créé le" />
      </Datagrid>
    </List>
  ),
  show: () => (
    <Show>
      <SimpleShowLayout>
        <TextField source="status" />
        <NumberField locales="fr-FR" source="duration" label="Durée (sec)" />
        <TextField source="videoUrl" />
        <RecordingPlayer />
        <TextField source="createdAt" />
        <JsonField source="__all__" />
        <TechInfo />
        </SimpleShowLayout>
    </Show>
  ),
};
